import state from './Kpi/states'
import mutations from './Kpi/mutations'
import actions from './Kpi/actions'
import getters from './Kpi/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
